module.exports = __webpack_public_path__ + "668851c28888289881fd4adf2321ebbb.png";


//////////////////
// WEBPACK FOOTER
// ./assets/Images/SwiftImageIcons/Colored/1x/Mastercard.png
// module id = 536
// module chunks = 0